import {
    collection,
    doc,
    addDoc,
    getDocs,
    deleteDoc,
    query,
    where,
    CollectionReference,
    DocumentData,
    getCountFromServer,
    orderBy,
    limit,
    updateDoc,
    increment
} from "firebase/firestore";
import { fs } from "../firebase.ts";

interface Prompt {
    id?: string;
    date?: Date; // updated date

    did: string; // good for stats of non users // "" = global
    uid: string; // "" = not logged in

    prompt: string;
    count: number;
}

export class Prompts {
    private collection: CollectionReference<DocumentData>;

    constructor() {
        this.collection = collection(fs, "prompts");
    }

    async count(): Promise<number> {
        const snapshot = await getCountFromServer(this.collection);
        return snapshot.data().count;
    }

    // user
    async add(prompt: Prompt): Promise<Prompt> {
        const q = query(
            this.collection,
            prompt.uid
                ? where("uid", "==", prompt.uid)
                : where("did", "==", prompt.did),
            where("prompt", "==", prompt.prompt),
            limit(1)
        );
        await this.add2(prompt.prompt.toLowerCase());
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            const data = {
                date: new Date(),
                ...prompt
            };
            const docRef = await addDoc(this.collection, data);

            return {
                id: docRef.id,
                ...data
            };
        } else {
            const snap = querySnapshot.docs[0];
            const docRef = doc(fs, "prompts", snap.id);
            await updateDoc(docRef, {
                date: new Date(),
                count: increment(1)
            });

            return {
                id: snap.id,
                ...snap.data() // count = count + 1
            } as Prompt;
        }
    }

    // global
    async add2(prompt: string): Promise<Prompt> {
        const q = query(
            this.collection,
            where("did", "==", ""),
            where("prompt", "==", prompt),
            limit(1)
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            const data = {
                date: new Date(),
                did: "",
                uid: "",
                prompt,
                count: 1
            };
            const docRef = await addDoc(this.collection, data);

            return {
                id: docRef.id,
                ...data
            };
        } else {
            const snap = querySnapshot.docs[0];
            const docRef = doc(fs, "prompts", snap.id);
            await updateDoc(docRef, {
                date: new Date(),
                count: increment(1)
            });

            return {
                id: snap.id,
                ...snap.data() // count = count + 1
            } as Prompt;
        }
    }

    async get(
        did: string,
        uid: string,
        prompt: string,
        isGlobal = true
    ): Promise<Prompt[]> {
        const q = isGlobal
            ? query(
                  this.collection,
                  where("did", "==", ""),
                  orderBy("count", "desc"),
                  orderBy("date", "desc")
                  //limit(5)
              )
            : query(
                  this.collection,
                  uid ? where("uid", "==", uid) : where("did", "==", did),
                  orderBy("date", "desc")
                  //limit(5)
              );
        const querySnapshot = await getDocs(q);
        const prompts: Prompt[] = [];

        let count = 0;
        querySnapshot.forEach((doc) => {
            const data = {
                id: doc.id,
                ...doc.data()
            } as Prompt;

            if (
                count < 10 &&
                (!prompt ||
                    data.prompt.toLowerCase().includes(prompt.toLowerCase()))
            ) {
                prompts.push(data);
                count++;
            }
        });

        return prompts;
    }

    async remove(id: string) {
        const docRef = doc(fs, "prompts", id);
        await deleteDoc(docRef);
    }
}
